import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { CircleDollarSign } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchMonetization, GROUP_OPS_STR as S, type MonetizationRow } from './groupOpsApi'

/**
 * A4.20 — Monetizatsiya (boost). REAL: `/admin/group-ops/monetization` —
 * channel_boosts per guruh/kanal. MyGram bepul-boost modeli, shuning uchun boost
 * soni/darajasi ko'rsatiladi (soxta daromad qo'yilmaydi).
 */
export function GroupMonetization() {
  const columns = useMemo<AdminColumn<MonetizationRow>[]>(
    () => [
      {
        key: 'group_title',
        header: S.chat,
        type: 'text',
        width: 200,
        render: (r) => (
          <Link to={`/groups/${r.group_id}`} className="text-accent hover:underline">
            {r.group_title || `#${r.group_id}`}
          </Link>
        ),
      },
      { key: 'boosters', header: S.boosters, type: 'number', width: 130, align: 'right' },
      { key: 'level', header: S.level, type: 'number', width: 110, align: 'right' },
      { key: 'last_boost', header: S.lastBoost, type: 'date', width: 160 },
    ],
    [],
  )
  const fetcher = useCallback(fetchMonetization, [])
  return (
    <>
      <PageHeader title={S.monetization} screenId="A4.20" description={S.monetizationNote} />
      <DataTable<MonetizationRow>
        screenId="A4.20"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <CircleDollarSign size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
